import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess204031Status: 'idle',
    startProcess204031Error: undefined as any,
    loadUserParamsProcess204031Status: 'idle',
    loadUserParamsProcess204031Error: undefined as any,

    process204031List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess204031 = createAsyncThunk('process204031Slice/startProcess204031', async ({ process204031 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess204031/`,
        prepareData(process204031),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess204031Status } = getState().process204031Slice
        return startProcess204031Status !== 'pending'
    }
})

export const loadUserParamsProcess204031 = createAsyncThunk('process204031Slice/loadUserParamsProcess204031', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess204031/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess204031Status } = getState().process204031Slice
        return loadUserParamsProcess204031Status !== 'pending'
    }
})

const Process204031Slice = createSlice({
    name: 'process204031Slice',
    initialState,
    reducers: {
        resetstartProcess204031: (state) => {
            state.job = undefined
            state.startProcess204031Error = undefined
        },
        resetstartProcess204031Error: (state) => {
            state.startProcess204031Error = undefined
        },
        resetloadUserParamsProcess204031: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess204031Error = undefined
        },
        resetloadUserParamsProcess204031Error: (state) => {
            state.loadUserParamsProcess204031Error = undefined
        },
        removeFromProcess204031ListById: (state, action) => {
            state.process204031List = state.process204031List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess204031ListByIds: (state, action) => {
            state.process204031List = state.process204031List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process204031List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess204031Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process204031List = []
            state.startProcess204031Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess204031.pending, (state) => {
            state.startProcess204031Status = 'pending'
            state.startProcess204031Error = undefined
        })
        builder.addCase(startProcess204031.fulfilled, (state, action) => {
            state.startProcess204031Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess204031.rejected, (state, action) => {
            state.startProcess204031Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess204031Error = action.error.message
            } else {
                state.startProcess204031Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess204031.pending, (state) => {
            state.loadUserParamsProcess204031Status = 'pending'
            state.loadUserParamsProcess204031Error = undefined
        })
        builder.addCase(loadUserParamsProcess204031.fulfilled, (state, action) => {
            state.loadUserParamsProcess204031Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess204031.rejected, (state, action) => {
            state.loadUserParamsProcess204031Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess204031Error = action.error.message
            } else {
                state.loadUserParamsProcess204031Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess204031,
    resetstartProcess204031Error,
    resetloadUserParamsProcess204031,
    resetloadUserParamsProcess204031Error,
    removeFromProcess204031ListById,
    removeFromProcess204031ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process204031Slice.actions
export default Process204031Slice.reducer
